module.exports = __webpack_public_path__ + "static/sztuka-bg.87140b5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/OfferSection/sztuka-bg.jpg
// module id = 649
// module chunks = 18089617347968